import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import App from './App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { MainPage } from './MainPage';
import { RSVP } from './modules/RSVP';
import { I18NContext } from './i18n/i18n';

function I18NProvider({ children }) {
    const [lang, setLang] = React.useState('hu');
    const value = {
        lang,
        setLang
    };

    return <I18NContext.Provider value={value}>{children}</I18NContext.Provider>;
}

const router = createBrowserRouter([
    {
        path: '/',
        element: <I18NProvider><App /></I18NProvider>,
        children: [
            {
                path: '',
                element: <MainPage />
            },
            {
                path: '/rsvp',
                element: <RSVP />,
            }
        ]
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <RouterProvider router={router} />
  // </React.StrictMode>
);

